import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import GuessFlagApp from './GuessFlagApp';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<GuessFlagApp />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js